
































import { Component, Vue, Prop } from 'vue-property-decorator';
import CommentEdit from './commentEdit.vue';
import moment from 'moment';
import {
  isCurrentAccountByName,
  computeFromNowMillisecond,
  timeFormat,
} from '@/utils/other';
import { requestDeleteComment } from './commentOperation';

type ICommentInfo = IComment.IResponse.ICommentInfo;
type ICreateOrUpdateComment = IComment.IRequest.ICreateOrUpdateComment;

@Component({
  components: {
    CommentEdit,
  },
})
export default class CommentItem extends Vue {
  @Prop() private comment!: ICommentInfo;
  @Prop() private url!: string;
  private moment = moment;
  private timer: boolean = true;
  private isEdit: boolean = false;
  private created() {
    this.initTimer();
  }
  get isNotMoreThan(): boolean {
    return computeFromNowMillisecond(this.createdOn) < 60 * 2; // 大于2分钟不可修改
  }
  get isCurrentAccount() {
    return isCurrentAccountByName(this.comment.createdName);
  }
  private initTimer() {
    if (this.isNotMoreThan) {
      let milliseconds = computeFromNowMillisecond(this.createdOn);
      milliseconds = milliseconds < 60 ? 60 * 2 : 60 * 2 - milliseconds; // 小于60秒,认为是本地刚提交,有2分钟修改时间
      setTimeout(() => {
        this.timer = false;
      }, milliseconds * 1000);
    }
  }
  get createdOn() {
    return timeFormat(this.comment.createdOn);
  }
  private updateSuccess(comment: ICreateOrUpdateComment) {
    this.comment.data = comment.comment;
    this.isEdit = false;
  }
  private handleDelete(commentId: string) {
    requestDeleteComment(commentId)
      .then((res) => {
        this.$message.success(res);
        this.$emit('delete', commentId);
      })
      .catch((err) => {
        this.$message.error(err);
      });
  }
}
